import { connect } from 'react-redux';
import { selectSortByValues, selectIsMobileMode } from '../selectors';
import { updateFilters } from '../dispatchers';
import { stringToSortBy } from '../types';
import { SortBySelector } from './SortBySelector';

/*
 * Note: this file only exists because it's still impossible difficult
 * to write a connected component with a type-safe mapDispatchToProps method...
 */

export const ConnectedSortBySelector = connect(
  (state) => ({
    values: selectSortByValues(state),
    mobileMode: selectIsMobileMode(state),
  }),
  (dispatch) => ({
    onChange: (values) => {
      dispatch(
        updateFilters({
          sortBy:
            values && values.length ? values.map(stringToSortBy) : undefined,
        })
      );
    },
  })
)(SortBySelector);
